// client/src/pages/admin/AdminDashboard.jsx
import { Box, Paper, Typography } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import DashboardStats from '../../components/admin/DashboardStats';
// Import other components like RecentActivity would go here

export default function AdminDashboard() {
  return (
    <AdminLayout pageTitle="Dashboard Overview">
      <DashboardStats />

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, mt: 3 }}>
        {/* Recent Activity Feed */}
        <Paper sx={{ p: 3, flex: 2 }}>
          <Typography variant="h6" gutterBottom fontWeight="600">
            Recent Activity
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {/* TODO: Replace with <RecentActivity /> component */}
            Activity feed will be displayed here. This will show events like
            "User123 submitted Task456", "NewAdmin logged in", etc.
          </Typography>
        </Paper>

        {/* System Health Status */}
        <Paper sx={{ p: 3, flex: 1 }}>
          <Typography variant="h6" gutterBottom fontWeight="600">
            System Health
          </Typography>
          <Typography variant="body2" color="success.main">
            • Database: Online
          </Typography>
          <Typography variant="body2" color="success.main">
            • API: Online
          </Typography>
          <Typography variant="body2" color="success.main">
            • Storage: Online
          </Typography>
          <Typography variant="body2" color="success.main">
            • Payments: Online
          </Typography>
        </Paper>
      </Box>
    </AdminLayout>
  );
}